import React, { useContext } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import RestrictToRole from '@components/RestrictToRole';
import { canRedirectTo, OTHER_APP_VERSION } from '@core/constants/appVersion';
import useAppVersionPreference from '@core/hooks/useAppVersionPreference';
import useSnackbar from '@core/hooks/useSnackbar';
import { AuthContext } from '@core/providers/AuthProvider';
import { RoleName } from '@core/types';
import buildAppSwitchUrl from '@core/utils/buildAppSwitchUrl';
import isCustomErroHandlerResponse from '@core/utils/isCustomErrorHandlerResponse';
import DesignSwitch, { DesignSwitchCheckIcon } from './DesignSwitch';

const LABEL_TEXT = 'Nuevo diseño';

const AppVersionSwitch = () => {
  const { setPreferredVersion } = useAppVersionPreference();
  const showSnackbar = useSnackbar();
  const { organization } = useContext(AuthContext);

  // Hide entirely if this deployment was never given the other app's URL
  // (missing/unresolved pipeline variable) — there'd be nowhere to send
  // the user, so don't offer a switch that can't work.
  if (!canRedirectTo(OTHER_APP_VERSION)) {
    return null;
  }

  const handleChange = async () => {
    const result = await setPreferredVersion(OTHER_APP_VERSION);

    if (!isCustomErroHandlerResponse(result) && result?.success) {
      window.location.href = buildAppSwitchUrl(OTHER_APP_VERSION, {
        organizationId: organization?.organizationId,
      });
      return;
    }

    showSnackbar({
      type: 'error',
      title: 'Error',
      message: 'No se pudo cambiar de versión. Intentá nuevamente.',
    });
  };

  return (
    <RestrictToRole allowedRoles={[RoleName.Radiologist]}>
      <FormControlLabel
        label={LABEL_TEXT}
        labelPlacement="start"
        // Hidden on mobile (below md, same cutoff as MobileViewerDisclaimer).
        sx={{ display: { xs: 'none', md: 'inline-flex' }, mx: 1, gap: 2 }}
        slotProps={{ typography: { variant: 'body2' } }}
        control={
          <DesignSwitch
            checked
            onChange={handleChange}
            checkedIcon={DesignSwitchCheckIcon}
            icon={DesignSwitchCheckIcon}
          />
        }
      />
    </RestrictToRole>
  );
};

export default AppVersionSwitch;
